import { getTasksData } from "common/store/reducers/tasks";

const isSameDay = (ts, offsetDays = 0) => {
  if (!ts) return false;

  const d = new Date(ts);
  const ref = new Date();
  ref.setDate(ref.getDate() + offsetDays);

  return (
    d.getDate() === ref.getDate() &&
    d.getMonth() === ref.getMonth() &&
    d.getFullYear() === ref.getFullYear()
  );
};

export const getTasksRepairedByDay = (tasksMap, offsetDays = 0) => {
  const tasks = getTasksData(tasksMap);

  return tasks.filter(
    t => Number(t.state) === 2 && isSameDay(t.dateRepaired, offsetDays)
  ).length;
};